import React, { useEffect, useState } from "react";
import { useTable, useGlobalFilter, usePagination } from "react-table";
import { connect } from "react-redux";
// import { GlobalFilter } from "./GlobalFilter";

const Paginated = ({ columns, data }) => {
    const { getTableProps, getTableBodyProps, rows, headerGroups, page, nextPage, previousPage, canPreviousPage, canNextPage, pageOptions, state, gotoPage, setPageSize, prepareRow, setGlobalFilter } = useTable(
        {
            columns,
            data,
        },
        useGlobalFilter,
        usePagination
    );
    const [selectedPageIndex, setSelectedPageIndex] = useState(1);
    const [pageArray, setPageArray] = useState();
    const [selectPage, setSelectPage] = useState();
    const { globalFilter, pageIndex, pageSize } = state;

    useEffect(() => {
            let tempTransactionCount = data.length / 10;
            let temp = Math.ceil(tempTransactionCount);
            setSelectPage(temp);
    }, [data]);
    useEffect(() => {
        const temp = Array.from({ length: selectPage }, (_, index) => index + 1);
        setPageArray(temp);
    }, [selectPage]);

    const handlePageIndex = (event) => {
        if (event.target.value !== "") {
            const number = event.target.value ? Number(event.target.value) - 1 : 0;
            gotoPage(number);
            setSelectedPageIndex(number);
        }
    };

    const handleNext = () => {
        if (selectedPageIndex < pageArray?.length) {
            setSelectedPageIndex(selectedPageIndex + 1);
            nextPage();
        }
    };
    const handlePrevious = () => {
        if (selectedPageIndex > 1) {
            setSelectedPageIndex(selectedPageIndex - 1);
            previousPage();
        }
    };

    return (
        <div className="customTable">
            <div className="customTable__body">
                <div className="table-responsive">
                    <table className="table table-striped table-bordered" {...getTableProps()}>
                        <thead>
                            {headerGroups.map((headerGroup) => (
                                <tr {...headerGroup.getHeaderGroupProps()}>
                                    {headerGroup.headers.map((column) => (
                                        <th {...column.getHeaderProps()}>{column.render("Header")}</th>
                                    ))}
                                </tr>
                            ))}
                        </thead>
                        {Array.isArray(data)? (
                            <tbody {...getTableBodyProps()}>
                                {page.map((row) => {
                                    prepareRow(row);
                                    return (
                                        <tr {...row.getRowProps()}>
                                            {row.cells.map((cell) => {
                                                return <td {...cell.getCellProps()}>{cell.render("Cell") ? cell.render("Cell") : "Null"}</td>;
                                            })}
                                        </tr>
                                    );
                                })}
                            </tbody>
                        ) : (
                            <tbody>
                                <tr>
                                    <td colSpan={9}>
                                        <p style={{ textAlign: "center", margin: 0 }}>No data found</p>
                                    </td>
                                </tr>
                            </tbody>
                        )}
                    </table>
                </div>
            </div>
            <div className="customTable__footer">
                <div className="customTable__right">
                    <div className="customTable__bottom">
                        <div className="customTable__buttons">
                            {/* <span className="btn btn-outline-primary" onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
								{"First"}
							</span> */}
                            <span className="btn btn-outline-primary" onClick={() => handlePrevious()} disabled={selectedPageIndex > 1 ? false : true}>
                                {"Previous"}
                            </span>
                            <span className="btn btn-outline-primary" onClick={() => handleNext()} disabled={pageArray?.length > 0 ? (selectedPageIndex === pageArray?.length ? true : false) : true}>
                                {"Next"}
                            </span>
                            {/* <span className="btn btn-outline-primary" onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
								{"Last"}
							</span> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
const mapStateToProps = (state) => ({});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Paginated);
